var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UseGiftCodeSuccessPanel',{on:{"useOtherCode":function($event){return _vm.$router.push({name: 'UseGiftCode'})},"viewOtherCodes":function($event){return _vm.$router.push({name: 'GiftCodeIndex'})}}})}
var staticRenderFns = []

export { render, staticRenderFns }